import { Injectable } from '@angular/core';
import { EmpowerGamingService } from './empower-gaming.service';
import { EmpowerModernLifeService } from './empower-modern-life.service';
import { EMPOWER_REPORT_GAMING, EMPOWER_REPORT_MODERN_LIFE } from '@algomusinc/domain';

@Injectable({ providedIn: 'root' })
export class EmpowerFactoryService {

  constructor(private modernLifeService: EmpowerModernLifeService, private gamingService: EmpowerGamingService) {
  }

  GetDataSerivce(serivceName: any) {
    let dataSerivceObject: any;
    switch (serivceName) {
      case EMPOWER_REPORT_MODERN_LIFE: {
        dataSerivceObject = this.modernLifeService;
        break;
      }
      case EMPOWER_REPORT_GAMING: {
        dataSerivceObject = this.gamingService;
      }
    }
    return dataSerivceObject;
  }


}

